export const base = {
  appName: '福昕智装',
  objective: '让设计更高效 让家装更省心',
  clickMore: '点击加载更多',
  loading: '正在加载更多数据...',
  noMore: '到底了~',
  cancel: '取消',
  searchHistory: '搜索历史',
  viewAll: '查看全部',
  hot: '热门',
  all: '全部',
  confirm: '确定',
  reset: '重置',
  syncWXInfo: '同步微信信息',
  delete: '删除',
  edit: '编辑',
  confirmToDelete: '确认要删除吗？',
  status: '状态',
  pleaseEnter: '请输入',
  remark: '备注',
  submit: '提交',
  pleaseChoose: '请选择',
  days: '{num}天',
  phone: '电话',
  viewMore: '查看更多',
  viewDetail: '查看详情',
};
